import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHouseholdsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 15C4.27 11.52 2.2 8.79 2.2 6.3C2.2 3.09675 4.79675 0.5 8 0.5C11.2033 0.5 13.8 3.09675 13.8 6.3C13.8 8.79 11.73 11.52 8 15ZM8 3L11 6V9H5V6L8 3Z",
		fill: "url(#paint0_linear_households_icon)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_households_icon",
		x1: 2.2,
		y1: 7.75,
		x2: 13.8,
		y2: 7.75,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", {
			offset: .00124008,
			stopColor: "#4B1DF4"
		}), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#A19AF8"
		})]
	}) })]
});
export default SvgHouseholdsIcon;
